import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../app/hooks";
import ObjectInsUpd from "../../../../features/base/page/ObjectInsUpd";
import { SubjectPerformedInfo } from "../../../../redux/curriculum/model";
import {
    selectSubjectPerformedInsUpd,
    subjectPerformedInsert,
    subjectPerformedInsUpdSlice,
    subjectPerformedUpdate,
} from "../../../../redux/curriculum/subjectPerformedInsUpdSlice";
import { subjectPerformedListSlice } from "../../../../redux/curriculum/subjectPerformedListSlice";
import { SubjectPerformedInsUpdData } from "./SubjectPerformedInsUpdData";
import { SubjectPerformedInsUpdReview } from "./SubjectPerformedInsUpdReview";

export interface SubjectPerformedInsUpdProps {
    back: () => void;
    schoolId: string;
    classroomId: string;
    subjectPerformed?: SubjectPerformedInfo;
}

export function SubjectPerformedInsUpd({ back, schoolId, classroomId, subjectPerformed }: SubjectPerformedInsUpdProps) {
    const dispatch = useAppDispatch();
    const insUpd = useSelector(selectSubjectPerformedInsUpd);

    const editing = subjectPerformed !== undefined;
    const sp = insUpd.subjectPerformed;

    if (editing) {
        if (sp.schoolId <= 0 && subjectPerformed) {
            dispatch(subjectPerformedInsUpdSlice.actions.set({ ...subjectPerformed }));
        }
    } else {
        if (sp.schoolId <= 0) {
            dispatch(subjectPerformedInsUpdSlice.actions.set({
                ...sp,
                schoolId: Number(schoolId),
                classroomId: Number(classroomId),
            }));
        }
    }

    const steps = [
        {
            name: "Dados da Aula",
            component: <SubjectPerformedInsUpdData />,
            check: () => sp.subjectId > 0 && !!sp.startedAt,
        },
        {
            name: "Revisão",
            component: <SubjectPerformedInsUpdReview />,
        },
    ];

    return <ObjectInsUpd
        name="aula ministrada"
        submit={() =>
            editing
                ? dispatch(subjectPerformedUpdate({ subjectPerformedId: subjectPerformed!.id, subjectPerformed: sp }))
                : dispatch(subjectPerformedInsert({ subjectPerformed: sp }))
        }
        backTo={back}
        backCleanup={() => {
            dispatch(subjectPerformedListSlice.actions.clean());
            dispatch(subjectPerformedInsUpdSlice.actions.clean());
        }}
        state={insUpd.state}
        steps={steps}
        edit={editing}
    />;
}
